import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithReauth } from '../../utils/baseQueryWithReauth';
import {
  ProductTypeResponse,
  ProductSubTypeResponse,
  ProductUomResponse,
  ProductStatusResponse,
  ProductMarginTypeResponse,
  ProductCategoryResponse,
  ProductSubCategoryResponse,
  ProductUomTypeResponse,
  ListOfValuesResponse,
} from './masterDataTypes';

const baseMasterDataQuery = createBaseQueryWithReauth({
  baseUrl: process.env.REACT_APP_MASTER_DATA_API_URL || '',
});

export const masterDataApiSlice = createApi({
  reducerPath: 'masterDataApi',
  baseQuery: baseMasterDataQuery,
  endpoints: (builder) => ({
    getListOfValues: builder.query<ListOfValuesResponse, {}>({
      query: (data) => ({
        url: `/`,
        method: 'GET',
      }),
    }),
    getProductType: builder.query<ProductTypeResponse, {}>({
      query: (data) => ({
        url: `/Products/GetProductType`,
        method: 'GET',
      }),
    }),
    getProductSubType: builder.query<ProductSubTypeResponse, {}>({
      query: (data) => ({
        url: `/Products/GetProductTypeSub`,
        method: 'GET',
      }),
    }),
    getProductUom: builder.query<ProductUomResponse, {}>({
      query: (data) => ({
        url: `/Products/GetProductUOM`,
        method: 'GET',
      }),
    }),
    getProductStatus: builder.query<ProductStatusResponse, {}>({
      query: (data) => ({
        url: `/Products/GetProductStatus`,
        method: 'GET',
      }),
    }),
    getProductMarginType: builder.query<ProductMarginTypeResponse, {}>({
      query: (data) => ({
        url: `/Products/GetProductMarginType`,
        method: 'GET',
      }),
    }),
    getProductCategory: builder.query<ProductCategoryResponse, {}>({
      query: (data) => ({
        url: `/Products/GetProductCategory`,
        method: 'GET',
      }),
    }),
    getProductSubCategory: builder.query<ProductSubCategoryResponse, {}>({
      query: (data) => ({
        url: `/Products/GetProductSubCategory`,
        method: 'GET',
      }),
    }),
    getProductUomType: builder.query<ProductUomTypeResponse, {}>({
      query: (data) => ({
        url: `/Products/GetProductUomType`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetProductTypeQuery,
  useGetProductSubTypeQuery,
  useGetProductUomQuery,
  useGetProductStatusQuery,
  useGetProductMarginTypeQuery,
  useGetProductCategoryQuery,
  useGetProductSubCategoryQuery,
  useGetProductUomTypeQuery,
  useGetListOfValuesQuery,
} = masterDataApiSlice;
